/**
 * @generated SignedSource<<d19599287ebd5c2aca3f97d10b641e30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type V2AgentThoughtProcessRenderer_toolCall$data = {
  readonly toolUse: {
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"V2ToolButton_toolCall">;
  readonly " $fragmentType": "V2AgentThoughtProcessRenderer_toolCall";
};
export type V2AgentThoughtProcessRenderer_toolCall$key = {
  readonly " $data"?: V2AgentThoughtProcessRenderer_toolCall$data;
  readonly " $fragmentSpreads": FragmentRefs<"V2AgentThoughtProcessRenderer_toolCall">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "V2AgentThoughtProcessRenderer_toolCall",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "V2ToolButton_toolCall"
    }
  ],
  "type": "GraphQLMessageToolCall",
  "abstractKey": null
};

(node as any).hash = "45e840c537865901443b0eab44b36c10";

export default node;
